<template>
  <div id="tab_charts" class="tab-pane fade in active">
    <div class="tab__header">Monthly Trending Charts</div>
    <div class="grid panel">
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Tests Per Month</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <TestsPerMonth></TestsPerMonth>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Vials Per Month</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <VialsPerMonth></VialsPerMonth>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid panel">
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Injections Per Month</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <InjectionsPerMonth></InjectionsPerMonth>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Errors Per Month</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <ErrorsPerMonth></ErrorsPerMonth>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid panel">
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Tests Per Physician</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <TestsPerPhysician></TestsPerPhysician>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col--6">
        <div class="stats__wrapper">
          <div class="grid stats__header">
            <div class="grid__col--12 stats__header--name">Tests Per Tech</div>
          </div>
          <div class="grid stats__body">
            <div class="grid__col--12 stats__body--data">
              <TestsPerTech></TestsPerTech>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TestsPerMonth from './trending-charts/TestsPerMonth.vue';
  import VialsPerMonth from './trending-charts/VialsPerMonth.vue';
  import InjectionsPerMonth from './trending-charts/InjectionsPerMonth.vue';
  import ErrorsPerMonth from './trending-charts/ErrorsPerMonth.vue';
  import TestsPerPhysician from './trending-charts/TestsPerPhysician.vue';
  import TestsPerTech from './trending-charts/TestsPerTech.vue';

  export default {
    name: 'Charts',
    components: {
      TestsPerMonth,
      VialsPerMonth,
      InjectionsPerMonth,
      ErrorsPerMonth,
      TestsPerPhysician,
      TestsPerTech,
    },
  };
</script>

<style lang="scss" scoped>
  .chart {
    @include e('wrapper') {
      padding: 0px 10px;
    }
  }

  .stats__wrapper {
    //border: 1px solid $mystic;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
    border-radius: 6px;
    background: #FFF;
  }
  .stats {
    @include e('header') {
      //border-bottom: 1px solid $mystic;
      background: $astronaut;
      border-radius: 6px 6px 0px 0px;

      @include m('name') {
        font-size: em(16px);
        font-weight: 300;
        color: #FFF;
        padding: 4px 8px;
      }

      @include m('menu') {

      }
    }

    @include e('body') {
      padding: 15px 5px 10px 5px;
    }

    @include e('category') {
      height: 98px;
      border: 1px solid $mystic;
      border-bottom: none;
      border-right: none;
      margin: 0;
      padding: 0;

      &:first-child {
        border-left: none;
      }

      @include m('stats') {
        .category__subtitle {
          font-size: 1.2em;
          font-weight: 700;
          margin-top: 20px;
          color: $east-bay;
        }
      }

      @include m('baseline') {
        .category__number-percent {
          text-align: center;
        }
      }
    }

    @include e('footer') {
      @include m('more') {
        font-size: em(14px);
        font-family: $font-family--secondary;
        font-weight: 300;
        text-align: center;
        padding: 10px 14px;
        border-radius: 0px 0px 6px 6px;
        cursor: pointer;

        &:hover {
          background: $foam;
        }
      }
    }
  }

  .category {
    @include e('box') {
      border-right: 1px solid $mystic;
      padding: 11px 0px;

      &:last-child {
        border-right: none;
      }

      @include m('change') {
        font-size: 1.3em;

        .category__number {
          padding: 8px 0 0 0;
        }
      }
    }

    @include e('title') {
      padding: em(4px);
      background: #00a5b6;
      color: white;
      font-family: $font-family--primary;
      font-weight: 400;
      text-transform: uppercase;
      text-align: center;
      font-size: em(14px);
    }

    @include e('subtitle') {
      //padding: 0.75em 0 0em 0;
      color: $basic-grey;
      font-family: $font-family--primary;
      font-weight: 400;
      text-align: center;
      font-size: em(14px);
    }

    @include e('number') {
      //padding: 0em 0 0.75em 0;
      color: $east-bay;
      font-family: $font-family--primary;
      font-weight: 600;
      text-align: center;
      font-size: em(18px);

      @include m('positive') {
        color: $friendly-green;
      }

      @include m('negative') {
        color: $friendly-red;
      }
    }

    @include e('number-percent') {
      font-size: 0.9em;
    }
  }

  .footer {
    @include e('expandable') {
      color: $levis;
    }
  }
</style>
